import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import AgreementDocument from '../../entities/tracing/agreementdocument'
import Agreement from '../../entities/tracing/agreement'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface AgreementDocumentState extends ListState<AgreementDocument>{
    editModel: AgreementDocument;
    agreement: number;
    itemLoading: boolean;
}
class AgreementDocumentModule extends ListModule<AgreementDocumentState,any,AgreementDocument>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<AgreementDocument>(),
        loading: false,
        itemLoading: false,
        editModel: new AgreementDocument(),
        activeList: new Array<AgreementDocument>(),
        agreement: 0,
        path: 'agreement-documents'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async upload(context: ActionContext<AgreementDocumentState, any>, payload: any) {
            context.state.itemLoading = true;
            let response = await Ajax.post('/api/agreement-documents-upload', payload.data).catch(e => {
                context.state.itemLoading = false;
                return Promise.reject(e);
            });
            context.state.itemLoading = false;
            context.state.list = response.data.result;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: AgreementDocumentState, model: Agreement) {
            state.editModel = Object.assign({});
            state.agreement = 0;
            if (model != undefined) {
                state.agreement = model.id;
            }
        },
        new(state: AgreementDocumentState) {
            state.editModel = Object.assign({});
            state.editModel.filename = null;
        },
    });
}
const agreementdocumentModule=new AgreementDocumentModule();
export default agreementdocumentModule;
